import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const uploadBulkTeachingVideoApi = createAsyncThunk(
  "SchoolResource-bulk/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.teachingVideosAction("upload", 1), data, { headers: { "Content-Type": "multipart/form-data" } })

      return response?.data;
    } catch (error) {
      //console.log("error",error);
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }
const uploadBulkTeachingVideoSlice = createSlice({
  name: "SchoolResource_bulk_upload",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetImage: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadBulkTeachingVideoApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(uploadBulkTeachingVideoApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(uploadBulkTeachingVideoApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetImage } = uploadBulkTeachingVideoSlice.actions;
export const uploadBulkTeachingVideoReducer = uploadBulkTeachingVideoSlice.reducer;
